import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ScheduleChannel {
  name: string;
  settings?: Record<string, any>;
}

export interface ScheduleData {
  scheduleDate: string;
  channels: ScheduleChannel[];
}

export interface ScheduleCampaignPayload {
  campaignId: string;
  scheduleData: ScheduleData;
}

export interface DeleteSchedulePayload {
  campaignId: string;
}

interface CampaignScheduleState {
  loading: boolean;
  error: string | null;
  success: boolean;
  deleteLoading: boolean;
  deleteError: string | null;
  deleteSuccess: boolean;
}

const initialState: CampaignScheduleState = {
  loading: false,
  error: null,
  success: false,
  deleteLoading: false,
  deleteError: null,
  deleteSuccess: false,
};

const campaignScheduleSlice = createSlice({
  name: 'campaignSchedule',
  initialState,
  reducers: {
    // Schedule Campaign
    scheduleCampaignRequest: (state, action: PayloadAction<ScheduleCampaignPayload>) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    scheduleCampaignSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    scheduleCampaignFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Delete Schedule
    deleteScheduleRequest: (state, action: PayloadAction<DeleteSchedulePayload>) => {
      state.deleteLoading = true;
      state.deleteError = null;
      state.deleteSuccess = false;
    },
    deleteScheduleSuccess: (state) => {
      state.deleteLoading = false;
      state.deleteSuccess = true;
      state.deleteError = null;
    },
    deleteScheduleFailure: (state, action: PayloadAction<string>) => {
      state.deleteLoading = false;
      state.deleteError = action.payload;
      state.deleteSuccess = false;
    },

    // Reset States
    resetScheduleState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    resetDeleteState: (state) => {
      state.deleteLoading = false;
      state.deleteError = null;
      state.deleteSuccess = false;
    },
  },
});

export const {
  scheduleCampaignRequest,
  scheduleCampaignSuccess,
  scheduleCampaignFailure,
  deleteScheduleRequest,
  deleteScheduleSuccess,
  deleteScheduleFailure,
  resetScheduleState,
  resetDeleteState,
} = campaignScheduleSlice.actions;

export default campaignScheduleSlice.reducer;
